import { api } from '@smena/ui';

/**
 * Транспорта оповещений два, и они независимы: свой бот, свой код, свой чат, своя колонка
 * адреса. Код Telegram MAX-ботом не принимается и наоборот - иначе человек получил бы
 * «готово» там, куда эскалации не пойдут.
 */
export type OpsNotifyTransport = 'telegram' | 'max';

/** Порядок фиксирован: Telegram - базовый транспорт, MAX - опция стенда. */
export const OPS_NOTIFY_TRANSPORTS: readonly OpsNotifyTransport[] = ['telegram', 'max'];

export interface OperatorNotifyStatus {
  /** Бот вообще поднят на нашей стороне. Без него подключать нечего. */
  botRunning: boolean;
  botUsername: string | null;
  connected: boolean;
  chatTitle: string | null;
  chatType: string | null;
  linkedAt: string | null;
}

export interface IssuedBindCode {
  code: string;
  expiresAt: string;
  /** null, если username бота неизвестен или у транспорта нет deep-link (MAX) - тогда код вносят /bind. */
  deepLink: string | null;
}

const BASE = '/api/staff/notifications/operator';

/**
 * `transport` у всех четырёх ручек необязателен и по умолчанию `telegram`, поэтому параметр
 * добавляется в URL только для явно переданного известного значения. Заодно это страхует от
 * классической ловушки react-query: `queryFn: fetchOperatorNotify` передаст первым аргументом
 * QueryFunctionContext, и без проверки в URL уехало бы `transport=[object Object]` - а неизвестное
 * значение ручки отбивают 400.
 */
function url(path: string, transport?: OpsNotifyTransport): string {
  return transport === 'telegram' || transport === 'max' ? `${path}?transport=${transport}` : path;
}

export function fetchOperatorNotify(transport?: OpsNotifyTransport): Promise<OperatorNotifyStatus> {
  return api<OperatorNotifyStatus>(url(BASE, transport));
}

export function issueBindCode(transport?: OpsNotifyTransport): Promise<IssuedBindCode> {
  return api<IssuedBindCode>(url(`${BASE}/code`, transport), { method: 'POST' });
}

export function unbindOperatorChat(transport?: OpsNotifyTransport): Promise<{ ok: true }> {
  return api(url(BASE, transport), { method: 'DELETE' });
}

export function sendOperatorTest(transport?: OpsNotifyTransport): Promise<{ ok: true }> {
  return api(url(`${BASE}/test`, transport), { method: 'POST' });
}

// Telegram отдаёт private/group/supergroup, MAX - dialog/chat/channel. Сырой тип показывать
// человеку нельзя: «supergroup» и «dialog» ничего не говорят о том, куда придут эскалации.
export function chatTypeLabel(type: string | null): string {
  if (type === 'private' || type === 'dialog') return 'личный чат';
  if (type === 'group' || type === 'supergroup' || type === 'chat') return 'чат команды';
  if (type === 'channel') return 'канал';
  return type ?? 'чат';
}
